// 统一的时间格式
export const DateTimeFormat = 'YYYY/MM/DD HH:mm:ss';
export const DateTimeFormatSimple = 'YYYY/MM/DD';

export const DateTimeFormats = 'YYYY-MM-DD'
